import { css } from "styled-components";

import { checkboxInputCss as sitesparkCheckboxInputCss } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html/input/styles/checkbox";

export const checkboxInputCss = css`
  ${sitesparkCheckboxInputCss}
  ${({
    theme: {
      colors: { blueGrey },
    },
  }) => `
    :checked + div {
      border: 1px solid ${blueGrey};
      background-color: ${blueGrey};
      transition: border 150ms ease-in;
    }
  `}
`;
